<script>
  import { createEventDispatcher } from 'svelte';
  import VisibilityGuard from '@components/VisibilityGuard.svelte';

  const dispatch = createEventDispatcher();

  export let imageSource;
</script>

<style style="text/scss" lang="scss">
  button {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    border-radius: 10px;
    border: 2px solid #ececec;
    padding: 8px;

    &:hover {
      background: #a893f9;
      border-color: #a893f9;
    }

    img {
      transition: opacity 0.2s;
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
</style>

<button
  class="emoji-button"
  on:click={() => {
    dispatch('click');
  }}>
  <VisibilityGuard let:hasBeenVisible>
    {#if hasBeenVisible}
      <div style="display: flex">
        <img class="emoji-image" src={imageSource} />
      </div>
    {/if}
  </VisibilityGuard>
</button>
